import React from "react";
import { Link } from "react-router-dom";
import styles from "./style.module.less";

const PPTableLink = ({ children, ...restProps }) => {
  return (
    <Link className={styles.pp_tbl_link} {...restProps}>
      {children}
    </Link>
  );
};

export default PPTableLink;
